import { useDistributionCentersStore } from './distributionCentersStore';

const normalize = (v: unknown) => String(v ?? '').trim();

export async function ensureDistributionCentersLoaded() {
    await useDistributionCentersStore.getState().fetch();
}

export function getDistributionCentersItems() {
    return useDistributionCentersStore.getState().items;
}

export function getDistributionCenterName(code: string): string {
    const normalizedCode = normalize(code);
    if (!normalizedCode) return '';

    const { byCode } = useDistributionCentersStore.getState();
    return byCode[normalizedCode] ?? normalizedCode;
}

export function getDistributionCenterCode(name: string): string {
    const normalizedName = normalize(name);
    if (!normalizedName) return '';

    const { items } = useDistributionCentersStore.getState();
    const found = items.find((dc) => dc.label === normalizedName);
    return found ? found.value : '';
}
